import { createFileRoute } from "@tanstack/react-router";
import { PageHeader, Prose } from "@/components/site/PageHeader";
import { EditablePageShell } from "@/components/site/EditablePageShell";
import { pageQueryOptions } from "@/lib/pages.functions";
import { SHARE_IMAGES } from "@/lib/share-images";

export const Route = createFileRoute("/about")({
  loader: ({ context }) => context.queryClient.ensureQueryData(pageQueryOptions("about")),
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.title || "About — Glow Long Golf" },
      { name: "description", content: loaderData?.meta_description || "Glow Long Golf was built by golfers tired of losing white balls in the dark. Direct-to-consumer glow-in-the-dark golf balls in six colors." },
      { property: "og:title", content: loaderData?.title || "About Glow Long Golf" },
      { property: "og:description", content: loaderData?.meta_description || "Why we built glow-in-the-dark golf balls in six colors — for night rounds, parties, and gifts." },
      { property: "og:url", content: "https://glowlonggolf.com/about" },
      { property: "og:image", content: SHARE_IMAGES.macroDew },
      { name: "twitter:image", content: SHARE_IMAGES.macroDew },
    ],
    links: [{ rel: "canonical", href: "https://glowlonggolf.com/about" }],
  }),

  errorComponent: ({ error }) => <div className="p-8 text-sm text-destructive" role="alert">{error.message}</div>,
  notFoundComponent: () => <div className="p-8 text-sm text-muted-foreground">Not found.</div>,
  component: AboutPage,
});

function AboutPage() {
  return (
    <EditablePageShell
      slug="about"
      defaults={{ eyebrow: "About", title: "We make night golf more fun", lead: "Glow Long Golf was built by golfers who got tired of losing white balls in the dark." }}
    >
      <Prose>
        <p>Glow Long started with a simple problem: night golf is awesome, but tracking a white ball after sunset is brutal. So we built a golf ball that charges under any light and stays bright after impact — in six brilliant colors so groups can tell their shots apart.</p>
        <p>We sell direct, ship from Amazon's fulfillment network, and stand behind every pack.</p>
        <p><strong>What we don't claim:</strong> we don't make distance or performance claims. Glow Long is recreational fun — for night rounds, gifts, parties, and backyard practice. If a course or tournament has rules about glow balls, follow them.</p>
      </Prose>
    </EditablePageShell>
  );
}
